import ServConfService from '@/application/services/Services'
import { t } from 'i18next'
import util from '@/application/libs/util';
/**
 * Helper function to focus an ag-grid cell 
 * @param {Object} grid ag-grid config object
 * @param {String} fieldName 
 * @param {Number} rowIndex 
 */
const focusCell = (grid, fieldName, rowIndex = 0) => {
    grid.gridControl.clearFocusedCell(); // clear current focused cells
    grid.gridControl.ensureColumnVisible(fieldName);
    grid.gridControl.startEditingCell({ rowIndex, colKey: fieldName});
};

/**
 * focust the plateGroupType cell that has the  
 * select auto-complete editor in it
 * @param {*} event ag-grid cellDoubleClickedEvent
 */
const _focusPlateGroupTypeAutocompleteCell = function(event) {
    focusCell(portioningSetGridConfiguration, "NMGRTIPOPR", event.rowIndex)
};

/**
 * Style to cells inside pinned top
 * row.
 */
const pinnedCellStyle = {
    'font-weight':'450',
    'color':'black',
    'background-color':'#c4c4c4'
};

/**
 * Style to cells inside pinned top
 * row.
 */
const ruleControlCellStyle = {
    'font-weight':'450',
    'color':'black',
    'background-color':'#c4c4c4',
    'text-align':'center'
};

/**
 * Style to cells from bunch toggle
 */
const toggleCellStyle = {
    'text-align':'center'
};

/**
 * Main screen grid configuration.
 */
const settingsGridConfiguration = {
    columnDefs: [],
    defaultColDef: {resizable: true, lockVisible: true, editable: true}
};

const monthSettingsGridConfiguration = {
    columnDefs: [],
    defaultColDef: {resizable: true, lockVisible: true, editable: true}
};

const addNewRowToPortioningSetGrid = function() {
    portioningSetGridConfiguration.addNewRowToGrid();
};
const addNewRowToDaysOutRutSetGrid = function() {
    daysOutRutSetGridConfiguration.addNewRowToGrid();
};
const addNewRowToLinkTypeDishesSetGrid = function() {
    const currentData = linkTypeDishesGridConfiguration.getRowData() || [];
    linkTypeDishesGridConfiguration.addNewRowToGrid();
    
    if (currentData.length > 0) {
        const lastRow = currentData[currentData.length - 1];
        const updatedData = linkTypeDishesGridConfiguration.getRowData();
        const newRow = updatedData[0];
        
        const fieldsToExclude = [
            'NRTIPOPRATCOMUMSERV',
            'NRSEQCNFCARDORIG',
            'NRORDEMORIG',
            'CDTIPOPRATORIG',
            'NMTIPOPRATORIG',
            'NRSEQCNFCARD',
            'NRORDCNFCARD',
            'CDTIPOPRAT',
            'NMTIPOPRAT'
        ];
        
        Object.keys(lastRow).forEach(key => {
            if (!fieldsToExclude.includes(key)) {
                newRow[key] = lastRow[key];
            } else {
                newRow[key] = null;
            }
        });
        if (!lastRow.__is_new_row){
            newRow.isNewRowWithLockedFields = true;   
        }
        
        if (linkTypeDishesGridConfiguration.setRowData) {
            linkTypeDishesGridConfiguration.setRowData(updatedData);
        }
    }
};
const isPlateGroupTypeEditable = function(rowInfo) {
    return !rowInfo.data.NRCONJUNTOPORCAO;
};

const __savePortioningSetCatch = (e) => {
    if(e !== null){
        const text = e && e.error || "";
        util.showErrorNotification({ title: t('error_when_saving_set_for_portioning'), text });
    }
};

const __saveDaysOutRutSetCatch = (e) => {
    if(e !== null){
        const text = e && e.error || "";
        util.showErrorNotification({ title: t('error_saving_non_routine_event_days'), text });
        daysOutRutSetGridConfiguration.reloadData();
    }
};

const savePortioningSet = function({data, node, colDef}) {
    const isNew = !data.NRCONJUNTOPORCAO;
    if(isNew){
        ServConfService.saveNewPortioningSet(data, colDef.field).then((newID) => {
            delete data.__is_new_row;
            data.NRCONJUNTOPORCAO = newID[0];
            portioningSetGridConfiguration.enableSelection();
            portioningSetGridConfiguration.updateRowNode({data, node, setIsAddingNewRow: false});
        }).catch(__savePortioningSetCatch)
    } else {
        ServConfService.updatePortioningSet(data).catch(__savePortioningSetCatch)
    }
};

const removePortioningSetRows = function() {
    portioningSetGridConfiguration.deleteCheckedRows(ServConfService.removePortioningSet);
};

const autoCalculateConsumptionPercentage = ({data, node}) => {
    return ServConfService.autoCalculateConsumptionPercentage(data).
        then(({VRCONJUNTOPORCAO}) => {
            const autoCalcWasSuccessful = VRCONJUNTOPORCAO !== null
            if(autoCalcWasSuccessful){
                const newRowData = {
                    ...data, 
                    VRCONJUNTOPORCAO
                };
                portioningSetGridConfiguration.updateRowNode({
                    data: newRowData,
                    node
                });
                util.showSuccessNotification({
                    title: t('successfully_calculated_portioning_percentage')
                });
                return VRCONJUNTOPORCAO
            } else {
                throw {
                    error: t('there_is_no_historical_consumption_percentage_for_this_set')
                }
            }
    }).catch(__savePortioningSetCatch);
};

const onAutoCalculateConsumptionClicked = (event) => {
    
    const {data, node} = event
    const {__is_new_row} = data
    autoCalculateConsumptionPercentage({data, node}).
        then((VRCONJUNTOPORCAO) => {
            if(__is_new_row){
                event.data = {...data, VRCONJUNTOPORCAO}
                savePortioningSet(event)
            }
        })
};

/**
 * portioning set grid configuration
 */
const portioningSetGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true,
        filterParams: { defaultOption: 'startsWith'}
    },
    columnDefs: [
        {
            headerValueGetter:()=> {return t('code') } , field: "CDGRTIPOPR", checkboxSelection: true, 
            onCellDoubleClicked: _focusPlateGroupTypeAutocompleteCell
        },
        {
            headerValueGetter:()=> {return t('group_tp_dish') } , field: "NMGRTIPOPR",
            editable: isPlateGroupTypeEditable, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: ServConfService.getPlateGroup,
                valueColumn: "CDGRTIPOPR",
                labelColumn: "NMGRTIPOPR",
                searchableColumns: ["CDGRTIPOPR" , "NMGRTIPOPR"],
                outDataColumns: ["CDGRTIPOPR"],
            }
        },
        {
            headerValueGetter:()=> {return t('percentage_of_consumption') } , field: "VRCONJUNTOPORCAO", editable: true
        },
        {
            headerValueGetter:()=> {return "" },
            editable: false,
            filter: false,
            cellStyle: {
                cursor: 'pointer',
                fontSize: '24px'
            },
            cellRenderer: () => `
            <i 
                title="Calcular porcionamento" 
                class="fas fa-calculator">
            </i>`,
            onCellClicked: onAutoCalculateConsumptionClicked
        }
    ],
    dataSource: ServConfService.getPortioningSets,
    onCellValueChanged: savePortioningSet
};

const saveDaysOutRutSet = function({data, node, colDef}) {
    const isNew = !data.NRCARDIAEVENTO;
    if(isNew){
        ServConfService.saveNewDayOutRutSet(data, colDef.field).then((newID) => {
            delete data.__is_new_row;
            data.NRCARDIAEVENTO = newID[0];
            daysOutRutSetGridConfiguration.enableSelection();
            daysOutRutSetGridConfiguration.updateRowNode({data, node, setIsAddingNewRow: false});
            util.showSuccessNotification({ title: t('non_routine_saved_event_day')});
        }).catch(__saveDaysOutRutSetCatch)
    } else {
        ServConfService.updateDaysOutRutSet(data, colDef.field).catch(__saveDaysOutRutSetCatch)
    }
};

const removeDaysOutRutSetRows = function() {
    daysOutRutSetGridConfiguration.deleteCheckedRows(ServConfService.removeDaysOutRutSet);
};

/**
 * days of event out of the rut set grid configuration
 */
const daysOutRutSetGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true,
        filterParams: { defaultOption: 'startsWith'}
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('date') } , field: "DTEVENTO", checkboxSelection: true,
            cellEditor: "dateCellEditor", editable: (e) => !e.data.NRCARDIAEVENTO
        },
        {
            headerValueGetter: ()=> {return t('customer_diners') } , field: "QTCLIESTICAR", editable: true
        },
        {
            headerValueGetter: ()=> {return t('donation_diners') } , field: "QTDOAESTICAR", editable: true
        },
        {
            headerValueGetter: ()=> {return t('staff_diners') } , field: "QTFUNESTICAR", editable: true
        }
    ],
    dataSource: ServConfService.getDaysOutRutSets,
    onCellValueChanged: saveDaysOutRutSet
};

const __saveLinkTypeDishesCatch = (e) => {
    if(e !== null){
        const text = e && e.error || "";
        util.showErrorNotification({ title: t('error_when_saving_link_types_of_dishes_between_services'), text });
        linkTypeDishesGridConfiguration.reloadData();
    }
};

const saveLinkTypeDishes = function({data, node, colDef}) {
    const isNew = !data.NRTIPOPRATCOMUMSERV;
    if(isNew){
        ServConfService.saveLinkTypeDishes(data, colDef.field).then((newID) => {
            delete data.__is_new_row;
            data.NRTIPOPRATCOMUMSERV = newID[0];
            linkTypeDishesGridConfiguration.enableSelection();
            linkTypeDishesGridConfiguration.updateRowNode({data, node, setIsAddingNewRow: false});
            util.showSuccessNotification({ title: t('link_types_of_dishes_between_saved_services')});
        }).catch(__saveLinkTypeDishesCatch)
    }
};

// Pega o resultado da seleção de uma coluna ao inserir um novo registro.
// OBS: Esse caso não serve para rows que possuem edição.
const getOriginDishes = function(data) {
    let allData = data.getRowData().filter((row) => row.__is_new_row);
    if(allData.length > 0) {
        return ServConfService.getOriginDishes(allData[0]);
    } else {
        return [];
    }
}

const getOriginDishesEditable = function(data) {
    let allData = data.getRowData();
    return ServConfService.getOriginDishes(allData[0]);
}

const removeLinkTypeDishesSetRows = function() {
    linkTypeDishesGridConfiguration.deleteCheckedRows(ServConfService.removeLinkTypeDishes);
};

let filialAux = null;

const linkTypeDishesGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true,
        filterParams: { defaultOption: 'startsWith'}
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('Source Unit') } , field: "FILIAL", checkboxSelection: true,
            editable: (e) => !e.data.NRTIPOPRATCOMUMSERV && !e.data.isNewRowWithLockedFields, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: ServConfService.getFilial,
                valueColumn: "CDFILIAL",
                labelColumn: "NMFILIAL",
                searchableColumns: ["NMFILIAL"]
            },
            onCellValueChanged: (params) => {
                filialAux = params.data.FILIAL_key;
            }
        },
        {
            headerValueGetter: ()=> {return t('origin_service') } , field: "CDNMSERVORIG",
            editable: (e) => !e.data.NRTIPOPRATCOMUMSERV && !e.data.isNewRowWithLockedFields, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: () => {
                    let filialValue = filialAux;
                    return ServConfService.getServByUnit(filialValue);
                },
                valueColumn: "CDSERVFILI",
                labelColumn: "CDNMSERVORIG",
                searchableColumns: ["CDSERVFILI" , "CDNMSERVORIG"],
                outDataColumns: ["CDSERVFILI", "CDNMSERVORIG"],
            },
        },
        {
            headerValueGetter: ()=> {return t('code_tp_dish_origin') } , field: "CDTIPOPRATORIG", editable: false,
            onCellDoubleClicked: () => focusCell(linkTypeDishesGridConfiguration, "NMTIPOPRATORIG"),
        },
        {
            headerValueGetter: ()=> {return t('type_dish_origin') } , field: "NMTIPOPRATORIG",
            editable: (e) => !e.data.NRTIPOPRATCOMUMSERV, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: () => getOriginDishesEditable(linkTypeDishesGridConfiguration),
                valueColumn: "CDTIPOPRATORIG",
                labelColumn: "NMTIPOPRATORIG",
                searchableColumns: ["CDTIPOPRATORIG", "NMTIPOPRATORIG"],
                outDataColumns: ["CDTIPOPRATORIG", "NRORDEMORIG", "NRSEQCNFCARDORIG"],
            },
        },
        {
            headerValueGetter: ()=> {return t('origin_column_origin') } , field: "NRORDEMORIG", editable: false,
            onCellDoubleClicked: () => focusCell(linkTypeDishesGridConfiguration, "NMTIPOPRATORIG"),
        },
        {
            headerValueGetter: ()=> {return t('code_type_destiny_dish') } , field: "CDTIPOPRAT",  editable: false,
            onCellDoubleClicked: () => focusCell(linkTypeDishesGridConfiguration, "NMTIPOPRAT"),
        },
        {
            headerValueGetter: ()=> {return t('type_destiny_dish') } , field: "NMTIPOPRAT",
            editable: (e) => !e.data.NRTIPOPRATCOMUMSERV, cellEditor: "vSelectCellEditor",
            cellEditorParams: {
                optionsSearchFunction: ServConfService.getDestineDishes,
                valueColumn: "CDTIPOPRAT",
                labelColumn: "NMTIPOPRAT",
                searchableColumns: ["CDTIPOPRAT" , "NMTIPOPRAT"],
                outDataColumns: ["CDTIPOPRAT", "NRORDCNFCARD", "NRSEQCNFCARD"],
            },
        },
        {
            headerValueGetter: ()=> {return t('destination_column_order') } , field: "NRORDCNFCARD", editable: false,
            onCellDoubleClicked: () => focusCell(linkTypeDishesGridConfiguration, "NMTIPOPRAT"),
        }
    ],
    dataSource: ServConfService.getLinkTypeDishes,
    onCellValueChanged: saveLinkTypeDishes
};

const saveExportDayOutOfRut = function(objectInsertList, data, modal) {
    ServConfService.generateLists(objectInsertList).then((response) => {
        if(response) { 
            if(data._mode == 'SOBREPOR') {
                deleteOverlap(response, data, modal);
            } else {
                insertExportData(response, data, modal);
            }
        }
    });
};

const saveExportConfCard = function(FILISERV, TABLE, ITEMS, MODE, PLATEGRID) {
   return  ServConfService.saveExportConfCard(FILISERV, TABLE, ITEMS, MODE, PLATEGRID);
};

const deleteOverlap = function(arrList, data, modal) {
    ServConfService.deleteOverlap(arrList[0]).then(() => {
        insertExportData(arrList, data, modal);
    });
};

const insertExportData = function(arrList, data, modal) {
    ServConfService.insertExportData(arrList[0], arrList[1]).then(() => {
        ServConfService.deleteLists(arrList).then(() => {
            data._showLoad = false;
            util.showSuccessNotification({
                title: t('successful_export')
            });
            modal.hide('export-form-modal');
        });
    });
};


/**
 * First column of the main grid.
 */
const gridDefaultFirstColumn = {
    headerName: "",
    field:'col_0',
    pinned: 'left',
    //pinned: 'left',
    cellStyle:function(params){
        if(params.node.rowPinned){
            return pinnedCellStyle;
        }
    },
    onCellClicked: (params) => orderColumnByRow(params, settingsGridConfiguration)
};

/**
 * After select/unselect row, trigger
 * function that save changes.
 */
const onChangeCellValue = function(params){
    const gridActionsConfig = {
        controlRow: {
            key: 'IDUTILPERCENTCONS',
            from: 'SERVCONFIG_PERC_SOURCE',
            successTitle: t('changed_percentage_source')
        },
        fixedColumn: {
            key: 'IDOTMCOLUNAFIXA',
            from: 'SERVCONFIG_FIXED_COLUMN',
            successTitle: t('changed_fixed_column')
        },
        NoColor: {
            key: 'IDOTMNAOCONSCOR',
            from: 'SERVCONFIG_NO_COLOR',
            successTitle: t('changed_no_color')
        },
        NoPreparationMode: {
            key: 'IDOTMNAOCONSMOD',
            from: 'SERVCONFIG_NO_PREPARATION_MODE',
            successTitle: t('changed_no_preparation_mode')
        },
        interleaveDishes: {
            key: 'IDOTMINTERCPRAT',
            from: 'SERVCONFIG_INTERLEAVE_DISHES',
            successTitle: t('changed_interleave_dishes')
        },
        percentualFix: {
            key: 'VRPERCENTUALFIXO',
            from: 'SERVCONFIG_VRPERCENTUALFIXO',
            successTitle: t('changed_percentualFix')
        }
    };
        
    const gridKey = Object.keys(gridActionsConfig).find((key) => params.data[key]);
    
    if(gridKey){
        ServConfService.saveChange(params.colDef, params.data, gridActionsConfig[gridKey]);
    }else{
        ServConfService.saveChangeOnPlateRow(params.colDef, params.data, params.newValue);
    }
};

const onChangeCellMonthValue = function(params){
    const data = params.data[`${params.colDef.field}_data`];
    
    const splitedData = data.IDMESATIVO.split('');
    splitedData[getIndexMonth(params.data['col_0'])] = params.data[`${params.colDef.field}_key`];
    data.IDMESATIVO = splitedData.join('');
    
    ServConfService.saveChangeOnControlMonthRow(data).then(() => {
        if(data.NRCONFCARDMESATIVO == null) controller.initMonthServiceScreen();
    });
};

const getIndexMonth = function(month) {
    switch (month) {
        case t('JANUARY'): return 0;        case t('FEBRUARY'): return 1;        case t('MARCH'): return 2;        case t('APRIL'): return 3;        case t('MAY'): return 4;        case t('JUNE'): return 5;        case t('JULY'): return 6;        case t('AUGUST'): return 7;        case t('SEPTEMBER'): return 8;        case t('OCTOBER'): return 9;        case t('NOVEMBER'): return 10;        case t('DECEMBER'): return 11;    }
};


/**
 * Default cell editor selector
 */
const cellEditorSelector = function(params){
    if(params.node.rowPinned && params.node.data.controlRow){
        return {
            component: 'optionsBunchCellEditor',
            params:{
                options: {
                    ATRATIVIDADE: t('attractiveness'),
                    HISTORICO: t('historic')
                }
            }
        };
    } else if(params.node.data.percentualFix){
        return {
            component: 'agTextCellEditor',
            params: {
                value: params.value
            }
        };
    } else {
        return {
            component: 'optionsBunchCellEditor',
            params:{
                options: {
                    S:`<i class="fas fa-check" style="text-align:'center'"/>`,
                    N:''
                }
            }
        };
    }
};

/**
 * Default cell renderer selector
 */
const cellRendererSelector = function(params){
    if(!params.node.data.controlRow && !params.node.data.percentualFix){
        return {
            component: 'optionsBunchCellRenderer'
        };
    }
};

/**
 * Order columns by row data.
 * 
 * @param {Object} params - Event params
 */
const orderColumnByRow = function(params, gridSettings){
    let columnApi = params.columnApi;
    let colKeys = [];
    
    gridSettings.columnDefs.forEach(col=>{
        let condition = params.data[col.field];
        condition = params.data.ordering ? condition : !condition;

        if(condition){
            colKeys.push(col.field);
        }
    });

    if(colKeys.length){
        columnApi.moveColumns(colKeys, 0);
        params.data.ordering = !params.data.ordering;
    }
};

const controller = {
    /**
     * Init grid configuration. Set dinamyc columns
     * according to plate groups.
     */
    initServiceScreen(){
        ServConfService.initServiceScreen(this);
    },

    initMonthServiceScreen() {
        ServConfService.initMonthServiceScreen(this);
    },

    /**
     * Initiate grid columns and rows.
     * 
     * @param {Object} controlContext 
     */
    setupGrid(colData, rowData){
        this.buildGridColumns(colData);
        this.buildGridControlRow(colData);
        this.buildGridRows(rowData, colData);
    },

    /**
     * Initiate grid columns and rows.
     * 
     * @param {Object} controlContext 
     */
    setupGridMonth(colData, rowData){
        this.buildMonthGridColumns(colData);
        this.buildMonthGridRows(rowData);
    },

    /**
     * Build grid columns according to plates types
     * passed as parameter.
     * 
     * @param {Array} columnsData
     */
    buildGridColumns(columnsData){
        this.settingsGridConfiguration.columnDefs.splice(0,this.settingsGridConfiguration.columnDefs.length);
        this.settingsGridConfiguration.columnDefs.push(this.gridDefaultFirstColumn);

        columnsData.forEach((colData, index)=>{
            colData.columnName = `col_${index+1}`;

            this.settingsGridConfiguration.columnDefs.push({
                headerName: colData.NMTIPOPRAT,
                field:`col_${index+1}`,
                cellStyle:function(params){
                    if(params.node.data.controlRow || params.node.data.plateGroupTypeRow){
                        return pinnedCellStyle;
                    } else if(params.node.data.fixedColumn || params.node.data.NoColor || params.node.data.NoPreparationMode || params.node.data.interleaveDishes || params.node.data.percentualFix) {
                        return ruleControlCellStyle;
                    }else {
                        return toggleCellStyle;
                    }
                },
                cellEditorSelector,
                cellRendererSelector,
                onCellValueChanged: function(params) {
                    onChangeCellValue(params);
                },
                editable: function(params) {
                    if(params.node.data.plateGroupTypeRow) {
                        return false;
                    }
                    return true;
                },
                sortable:true
            });
        }); 
    },

    buildMonthGridColumns(columnsData){
        this.monthSettingsGridConfiguration.columnDefs.splice(0,this.monthSettingsGridConfiguration.columnDefs.length);
        this.monthSettingsGridConfiguration.columnDefs.push(this.gridDefaultFirstColumn);

        columnsData.forEach((colData, index)=>{
            colData.columnName = `col_${index+1}`;

            this.monthSettingsGridConfiguration.columnDefs.push({
                headerName: colData.NMTIPOPRAT,
                field:`col_${index+1}`,
                cellStyle:function(params){
                    if(params.node.rowPinned){
                        return pinnedCellStyle;
                    } else {
                        return toggleCellStyle;
                    }
                },
                cellEditorSelector,
                cellRendererSelector,
                onCellValueChanged: onChangeCellMonthValue,
                editable:true,
                sortable:true
            });
        }); 
    },

    /**
     * Build grid first row, that controls grid
     * data.
     */
    buildGridControlRow(columns){
        let controlRow = [
            {
                controlRow: true,
                col_0: t('source_of_perc_consumption'),
                columnName: 'source_of_perc_consumption'
            },
            {
                plateGroupTypeRow: true,
                col_0: t('plate_group_type'),
                columnName: 'plate_group_type'
            },
            {
                interleaveDishes: true,
                col_0: t('interleaveDishes'),
                columnName: 'interleaveDishes'
            },
            {
                fixedColumn: true,
                col_0: t('fixedColumn'),
                columnName: 'fixedColumn'
            },
            {
                NoColor: true,
                col_0: t('NoColor'),
                columnName: 'NoColor'
            },
            {
                NoPreparationMode: true,
                col_0: t('NoPreparationMode'),
                columnName: 'NoPreparationMode'
            },
            {
                percentualFix: true,
                col_0: t('percentualFix'),
                columnName: 'percentualFix'
            }
        ];

        let percSource = {
            ATRATIVIDADE: t('attractiveness'),
            HISTORICO: t('historic')
        };

        columns.forEach((col, index)=>{
            controlRow.forEach((control)=>{
                switch (control.columnName) {
                    case 'plate_group_type':
                        control[`col_${index+1}`] = col.NMGRTIPOPR;
                    break;
                  case 'source_of_perc_consumption':
                    control[`col_${index+1}`] = percSource[col.IDUTILPERCENTCONS];
                    break;
                  case 'fixedColumn':
                    let setFixedColumn = col.IDOTMCOLUNAFIXA == 'S' ? col.IDOTMCOLUNAFIXA : 'N';
                    if (setFixedColumn == 'S') {
                        control[`col_${index+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    }
                    break;
                  case 'NoColor':
                    let setNoColor = col.IDOTMNAOCONSCOR == 'S' ? col.IDOTMNAOCONSCOR : 'N';
                    if (setNoColor == 'S') {
                        control[`col_${index+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    }
                    break;
                  case 'NoPreparationMode':
                    let setNoPreparationMode = col.IDOTMNAOCONSMOD == 'S' ? col.IDOTMNAOCONSMOD : 'N';
                    if (setNoPreparationMode == 'S') {
                        control[`col_${index+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    }
                    break;
                  case 'interleaveDishes':
                    let setInterleaveDishes = col.IDOTMINTERCPRAT == 'S' ? col.IDOTMINTERCPRAT : 'N';
                    if (setInterleaveDishes == 'S') {
                        control[`col_${index+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    }
                    break;
                  case 'percentualFix':
                      let setPercentualFix = (col.VRPERCENTUALFIXO) ? col.VRPERCENTUALFIXO : '';
                      control[`col_${index+1}`] = setPercentualFix;
                    break;
                }
            });
        });

        this.settingsGridConfiguration.gridControl.setPinnedTopRowData(controlRow);
    },

    /**
     * Build grid rows.
     */
    buildGridRows(rowData, colData){
        rowData.forEach(reg=>{
            reg.col_0 = reg.NMGRUPOPRATO;

            colData.forEach((col, index)=>{
                if(reg.NRSEQCNFCARD.includes(col.NRSEQCNFCARD)){
                    reg[`col_${index+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    reg[`col_${index+1}_key`] = `S`;
                }
            });
        });

        this.settingsGridConfiguration.setRowData(rowData);
    },

    buildMonthGridRows(rowData){
        const rowCard = this.getMonth();
        rowData.forEach((reg, idxData)=>{
            const arrMark = reg.IDMESATIVO.split('');
            arrMark.forEach((mark, index) => {
                if(mark == 'S') {
                    rowCard[index][`col_${idxData+1}`] = `<i class="fas fa-check" style="text-align:'center'"/>`;
                    rowCard[index][`col_${idxData+1}_key`] = `S`;
                    rowCard[index][`col_${idxData+1}_data`] = reg;
                } else {
                    rowCard[index][`col_${idxData+1}_data`] = reg;
                }
            });
        });
        this.monthSettingsGridConfiguration.setRowData(rowCard);
    },

    getMonth() {
        return [
            {  col_0: t('JANUARY') },
            {  col_0: t('FEBRUARY') },
            {  col_0: t('MARCH') },
            {  col_0: t('APRIL') },
            {  col_0: t('MAY') },
            {  col_0: t('JUNE') },
            {  col_0: t('JULY') },
            {  col_0: t('AUGUST') },
            {  col_0: t('SEPTEMBER') },
            {  col_0: t('OCTOBER') },
            {  col_0: t('NOVEMBER') },
            {  col_0: t('DECEMBER') },
        ];
    },

    settingsGridConfiguration,
    monthSettingsGridConfiguration,
    gridDefaultFirstColumn,
    portioningSetGridConfiguration,
    daysOutRutSetGridConfiguration,
    linkTypeDishesGridConfiguration,
    addNewRowToPortioningSetGrid,
    addNewRowToDaysOutRutSetGrid,
    addNewRowToLinkTypeDishesSetGrid,
    removePortioningSetRows,
    removeDaysOutRutSetRows,
    removeLinkTypeDishesSetRows,
    saveExportDayOutOfRut,
    saveExportConfCard
};

export default controller;